import { render, staticRenderFns } from "./ConfirmationEducationDelegate.vue?vue&type=template&id=1ddeb6bb"
import script from "./ConfirmationEducationDelegate.vue?vue&type=script&lang=ts"
export * from "./ConfirmationEducationDelegate.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationEducationDelegate.vue?vue&type=style&index=0&id=1ddeb6bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports